import { useEffect, useRef, useState } from "react";
import type { SwipeDirection } from "@/hooks/use-swipe-tabs";

interface Props {
  activeKey: string;
  swipeDirection: SwipeDirection;
  edgeBounce: "left" | "right" | null;
  onAnimationDone: () => void;
  onEdgeBounceDone: () => void;
  children: React.ReactNode;
}

const SwipeAnimatedContent = ({ activeKey, swipeDirection, edgeBounce, onAnimationDone, onEdgeBounceDone, children }: Props) => {
  const [animClass, setAnimClass] = useState("");
  const prevKey = useRef(activeKey);

  useEffect(() => {
    if (activeKey !== prevKey.current) {
      if (swipeDirection === "left") {
        setAnimClass("animate-slide-in-from-right");
      } else if (swipeDirection === "right") {
        setAnimClass("animate-slide-in-from-left");
      } else {
        setAnimClass("animate-fade-in");
      }
      prevKey.current = activeKey;

      const t = setTimeout(() => {
        setAnimClass("");
        onAnimationDone();
      }, 250);
      return () => clearTimeout(t);
    }
  }, [activeKey, swipeDirection, onAnimationDone]);

  useEffect(() => {
    if (edgeBounce) {
      setAnimClass(edgeBounce === "left" ? "animate-edge-bounce-left" : "animate-edge-bounce-right");
      const t = setTimeout(() => {
        setAnimClass("");
        onEdgeBounceDone();
      }, 300);
      return () => clearTimeout(t);
    }
  }, [edgeBounce, onEdgeBounceDone]);

  return <div className={animClass}>{children}</div>;
};

export default SwipeAnimatedContent;
